export default __webpack_public_path__ + "static/media/img_base_grey.9ecbcde1.jpg";